import {
    CREATE_BRAND_MASTER_FAILURE,
    CREATE_BRAND_MASTER_REQUEST,
    CREATE_BRAND_MASTER_SUCCESS,
    CREATE_USER_FORM_BRAND_MASTER,
    DELETE_BRAND_MASTER_FAILURE,
    DELETE_BRAND_MASTER_REQUEST,
    DELETE_BRAND_MASTER_SUCCESS,
    FETCH_BRAND_MASTER_FAILURE,
    FETCH_BRAND_MASTER_REQUEST,
    FETCH_BRAND_MASTER_SUCCESS,
    FETCH_SINGLE_BRAND_MASTER_FAILURE,
    FETCH_SINGLE_BRAND_MASTER_REQUEST,
    FETCH_SINGLE_BRAND_MASTER_SUCCESS,
    BRAND_MASTER_USERFORM_RESET,
    UPDATE_BRAND_MASTER_FAILURE,
    UPDATE_BRAND_MASTER_REQUEST,
    UPDATE_BRAND_MASTER_SUCCESS,
    FETCH_BUYER_NAME_MASTER_REQUEST,
    FETCH_BUYER_NAME_MASTER_SUCCESS,
    FETCH_BUYER_NAME_MASTER_FAILURE
} from './brandMaster.actionsType';

export const BRAND_MASTER = 'brandMaster';

let initialState = {
    loading: false,
    brandMasterList: [],
    buyerNameList: [],
    userform: { brandType: 'O' },
    dropdownProperty: {},
    selectedBrand: {},
    errorMessage: ''
};

export let brandMasterReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_BRAND_MASTER_REQUEST:
        case CREATE_BRAND_MASTER_REQUEST:
        case UPDATE_BRAND_MASTER_REQUEST:
        case FETCH_SINGLE_BRAND_MASTER_REQUEST:
        case DELETE_BRAND_MASTER_REQUEST:
        case FETCH_BUYER_NAME_MASTER_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_BRAND_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                brandMasterList: updatePayload
            };
        case FETCH_BUYER_NAME_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                buyerNameList: updatePayload
            };
        case CREATE_BRAND_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {},
                selectedBrand: {}
            };
        case UPDATE_BRAND_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {},
                selectedBrand: {}
            };
        case FETCH_SINGLE_BRAND_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedBrand: updatePayload,
                userform: {
                    brandType: updatePayload.fldBrandType,
                    brand: updatePayload.fldBrandName,
                    buyerName: updatePayload.fldFKBuyerName,
                    sdescription: updatePayload.fldShortName
                }
            };
        case DELETE_BRAND_MASTER_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case FETCH_BRAND_MASTER_FAILURE:
        case CREATE_BRAND_MASTER_FAILURE:
        case UPDATE_BRAND_MASTER_FAILURE:
        case FETCH_SINGLE_BRAND_MASTER_FAILURE:
        case DELETE_BRAND_MASTER_FAILURE:
        case FETCH_BUYER_NAME_MASTER_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_BRAND_MASTER:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case BRAND_MASTER_USERFORM_RESET:
            return {
                ...state,
                userform: { brandType: 'O' },
                selectedBrand: {}
            };
        default:
            return state;
    }
};
